<script>

export default {
  name: "RefundIcon",
  props: {
    color: {
      type: String,
      default: "currentColor",
    },
  }
};

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" role="img" aria-label="Ícone de reembolso">
    <title>Ícone de reembolso</title>
    <path
      d="M9.80898 6.29726C9.71632 6.03478 9.54446 5.80751 9.3171 5.64678C9.08975 5.48606 8.81811 5.3998 8.53964 5.39991H7.49763C7.20035 5.39835 6.91305 5.50703 6.6913 5.70493C6.46954 5.90283 6.32907 6.17589 6.29706 6.47131C6.26505 6.76673 6.34377 7.06352 6.518 7.30428C6.69222 7.54505 6.94958 7.71269 7.2403 7.77479L8.82697 8.12082C9.15261 8.19068 9.4408 8.37869 9.63587 8.64852C9.83094 8.91835 9.91904 9.25086 9.88318 9.58183C9.84731 9.9128 9.69001 10.2187 9.44166 10.4406C9.19332 10.6624 8.87154 10.7844 8.53849 10.7829H7.64187C7.05567 10.7829 6.55716 10.408 6.37253 9.88554M8.09075 5.39991V4.05387M8.09075 12.1278V10.7829M2.47796 15.7449V12.8614H5.36283M15.6214 6.87051C15.9277 8.50284 15.6832 10.1906 14.926 11.669C14.1689 13.1474 12.9421 14.3326 11.4382 15.0387C9.93429 15.7448 8.23838 15.9317 6.61666 15.5702C4.99494 15.2087 3.53921 14.3192 2.47796 13.0413M0.878595 9.62949C0.572251 7.99716 0.816832 6.30936 1.57395 4.83099C2.33107 3.35263 3.55786 2.16739 5.06178 1.46131C6.5657 0.755224 8.26162 0.568265 9.88334 0.929775C11.5051 1.29129 12.9608 2.1808 14.022 3.45871M14.022 0.755095V3.63864H11.1372"
      :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>